export default "__VITE_ASSET__D3JvTo8l__"